<template>
    <li>
      <span v-if="debug === 'true' || debug === true">{{version}}</span>
        <div class="d-flex" >
            <b-icon style="margin-right: .3em; margin-top: 2%;" icon="chevron-down" :rotate=" itemKit.verTrts ? 180 : 0" @click="toggleBranch()"></b-icon>
            <p class="mt-2" @click="seleccionarKit(itemKit)">{{ itemKit.nombreKit}}</p>
        </div>
        <ul v-if="itemKit.verTrts" :class="{ 'nested': true, 'active': itemKit.verTrts }">
            <div v-for="(trt,indexT) in itemKit.listaTratamientos" :key="indexT" style="color: gray;">
                <em class="tratamiento_outline_inactivo" style="width: 1.4em;"></em>
                <span>{{ trt.nombreTratamiento }}</span>
            </div>
        </ul>
    </li>
</template>

  
<script>
    export default {
        name: 'Kits',
        props: {
            indexPadecimiento: Number,
            indexOpcion: Number,
            i: Number,
            itemKit: Object,
            idSeleccionado: {
                type: Number,
                default: null
            },
            indexKit: Number,
        },
        data() {
            return {
              version: process.env.VUE_APP_ENV_VERSION,
              debug: false,
            };
        },
      created() {
        this.debug = this.$localStorageService.getDebug();
      },
        methods: {
            seleccionarKit(item){
                this.$emit('seleccionarKit', item);
            },

            toggleBranch() {
                this.itemKit.verTrts = !this.itemKit.verTrts;
            },
        },
    };
</script>
  
<style scoped>
    ul, #myUL {
        list-style-type: none;
    }
    
    #myUL {
        margin: 0;
        padding: 0;
    }

    .nested {
        display: none;
    }
    
    .active {
        display: block;
    }
</style>